import * as React from "react";
import type { SVGProps } from "react";

interface PenaltyProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Penalty = ({ cancelled = false, ...props }: PenaltyProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none">
      <path
        fill="#FFF"
        d="M12 .75a11.25 11.25 0 1 0 0 22.5 11.25 11.25 0 0 0 0-22.5"
      />
      <path
        fill="#000"
        d="M12 1.7a10.3 10.3 0 1 0 0 20.6 10.3 10.3 0 0 0 0-20.6M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18"
      />
      <path
        fill="#FF1212"
        d="M9.21 17.8c-.6 0-.91-.31-.91-.94V7.54c0-.63.31-.94.94-.94h4.18c1.05 0 1.87.25 2.49.74.61.49.92 1.31.92 2.48 0 1.16-.3 2-.92 2.5s-1.44.74-2.49.74h-3.28v3.8c0 .63-.3.94-.93.94m.93-6.46h3.02a2 2 0 0 0 1.27-.36c.3-.23.45-.62.45-1.16s-.15-.92-.45-1.16a2 2 0 0 0-1.27-.35h-3.02z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Penalty;
